import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export const newKey = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
